module.exports = __webpack_public_path__ + "static/media/warehouse.10a9ea56.jpg";